import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, StarIcon } from 'lucide-react';
const testimonials = [{
  id: 1,
  quote: 'Redline Pool Tile did an amazing job! Our pool tiles were covered in calcium buildup, and now they look brand new. The team was professional, quick, and friendly. Highly recommend!',
  name: 'Mike P.',
  location: 'Phoenix, AZ'
}, {
  id: 2,
  quote: 'Super happy with the service and price! They came over that day to give me a price and followed up a few days later and cleaned the tile. They did a great job!',
  name: 'Michael R.',
  location: 'Scottsdale, AZ'
}, {
  id: 3,
  quote: 'Our pool looks new again and service was prompt. We are so happy and would highly recommend.',
  name: 'Eileen W.',
  location: 'Mesa, AZ'
}];
export function TestimonialsSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const next = () => {
    setActiveIndex(current => current === testimonials.length - 1 ? 0 : current + 1);
  };
  const prev = () => {
    setActiveIndex(current => current === 0 ? testimonials.length - 1 : current - 1);
  };
  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStart(e.targetTouches[0].clientX);
  };
  const handleTouchMove = (e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };
  const handleTouchEnd = () => {
    if (touchStart - touchEnd > 50) {
      next(); // Swipe left
    }
    if (touchStart - touchEnd < -50) {
      prev(); // Swipe right
    }
  };
  return <section id="testimonials" className="py-16 md:py-24 px-6 bg-light-gray overflow-hidden" data-id="element-177">
      <div className="container mx-auto max-w-5xl text-center" data-id="element-178">
        <span className="text-brand-red uppercase text-sm font-bold tracking-wider block mb-3" data-id="element-179">
          Testimonials
        </span>
        <h2 className="text-charcoal text-3xl md:text-4xl font-bold uppercase tracking-wide mb-12" data-id="element-180">
          What Our Clients Say
        </h2>

        <div className="relative px-4 md:px-16" data-id="element-181">
          {/* Carousel Container */}
          <div className="overflow-hidden relative min-h-[300px] md:min-h-[250px]" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} data-id="element-182">
            <div className="flex transition-transform duration-500 ease-in-out h-full items-center" style={{
            transform: `translateX(-${activeIndex * 100}%)`
          }} data-id="element-183">
              {testimonials.map(testimonial => <div key={testimonial.id} className="w-full flex-shrink-0 px-2 md:px-4" data-id="element-184">
                  <div className="bg-white p-6 md:p-10 rounded-2xl shadow-lg border border-gray-100 flex flex-col items-center h-full" data-id="element-185">
                    <div className="flex gap-1 mb-6" data-id="element-186">
                      {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-6 h-6 fill-yellow-400 text-yellow-400" data-id="element-187" />)}
                    </div>
                    <p className="text-gray-700 text-lg md:text-xl italic mb-8 leading-relaxed" data-id="element-188">
                      "{testimonial.quote}"
                    </p>
                    <div className="mt-auto" data-id="element-189">
                      <p className="font-bold text-charcoal text-lg" data-id="element-190">
                        {testimonial.name}
                      </p>
                      <p className="text-gray-500" data-id="element-191">{testimonial.location}</p>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Navigation Buttons (Desktop) */}
          <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 bg-white p-3 rounded-full shadow-md text-navy hover:text-brand-red hover:scale-110 transition-all hidden md:block" aria-label="Previous testimonial" data-id="element-192">
            <ChevronLeftIcon size={24} data-id="element-193" />
          </button>
          <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 bg-white p-3 rounded-full shadow-md text-navy hover:text-brand-red hover:scale-110 transition-all hidden md:block" aria-label="Next testimonial" data-id="element-194">
            <ChevronRightIcon size={24} data-id="element-195" />
          </button>
        </div>

        {/* Dots Indicator */}
        <div className="flex justify-center gap-3 mt-8" data-id="element-196">
          {testimonials.map((_, idx) => <button key={idx} onClick={() => setActiveIndex(idx)} className={`w-3 h-3 rounded-full transition-all duration-300 ${activeIndex === idx ? 'bg-brand-red w-8' : 'bg-gray-300 hover:bg-gray-400'}`} aria-label={`Go to testimonial ${idx + 1}`} data-id="element-197" />)}
        </div>

        {/* Google Review Badge */}
        <div className="mt-12 inline-flex items-center gap-2 bg-white px-6 py-3 rounded-full shadow-sm border border-gray-200" data-id="element-198">
          <span className="text-yellow-500 text-xl" data-id="element-199">★</span>
          <span className="font-bold text-charcoal" data-id="element-200">5.0 Rating</span>
          <span className="text-gray-500" data-id="element-201">on Google Reviews</span>
        </div>
      </div>
    </section>;
}